import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Demo.css';

export default function Demo() {
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll('.demo .animate-side');
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const handleClick = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    navigate('/video');
  };

  return (
    <section className="demo">
      <h1 className="animate-side slide-left">
        Ready to see it live?
      </h1>

      <div className="demo-subtitle animate-side slide-right">
        Watch a personalized walkthrough.
      </div>

      <div className="demo1">
        <div className="demo2">
          <p className="animate-side slide-left">
            Discover how our system adapts to your unique workflow. Our team will guide you through setup, feature highlights, and answer any questions.
          </p>

          <a
            href="/video"
            className="button-link animate-side slide-right"
            onClick={handleClick}
          >
            Visit Demo Videos
          </a>
        </div>
      </div>
    </section>
  );
}